/*
 * Volo X EZ AI landing page: progressive sticky CTA.
 * The bar is hidden by default in CSS, so with JS disabled nothing is broken --
 * the inline hero, reasons and closing CTAs remain the only calls to action.
 * The bar reveals once the hero CTA has scrolled out of view and hides again
 * when the closing CTA is on screen, so it never covers the final call to action.
 */
(function () {
  'use strict';

  function init(root) {
    var bar = root.querySelector('[data-vxez-sticky]');
    var heroAnchor = root.querySelector('[data-vxez-hero-cta]');
    var finalAnchor = root.querySelector('[data-vxez-final-cta]');

    if (!bar || !heroAnchor || !('IntersectionObserver' in window)) return;

    var heroPassed = false;
    var finalVisible = false;
    var finalPassed = false;

    var update = function () {
      bar.setAttribute('data-vxez-show', heroPassed && !finalVisible && !finalPassed ? 'true' : 'false');
    };

    var heroObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          heroPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          update();
        });
      },
      { rootMargin: '0px 0px -8px 0px', threshold: 0 }
    );
    heroObserver.observe(heroAnchor);

    if (finalAnchor) {
      var finalObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            finalVisible = entry.isIntersecting;
            finalPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            update();
          });
        },
        { threshold: 0 }
      );
      finalObserver.observe(finalAnchor);
      root.vxezFinalObserver = finalObserver;
    }

    root.vxezHeroObserver = heroObserver;
    update();
  }

  function destroy(root) {
    if (root.vxezHeroObserver) root.vxezHeroObserver.disconnect();
    if (root.vxezFinalObserver) root.vxezFinalObserver.disconnect();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-vxez-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-vxez-root]').forEach(destroy);
  });
})();
